import React, { Component } from 'react';
import { logError } from '../services/Logger';
import { auth } from '../firebase';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        const user = auth.currentUser;
        logError(user, 'REACT_UI_CRASH', error.message, errorInfo.componentStack, {
            url: window.location.href
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '40px', textAlign: 'center', marginTop: '50px', backgroundColor: '#fdf2f2', border: '1px solid #f8cbcb', borderRadius: '8px', maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
                    <h2 style={{ color: '#dc3545' }}>Oops! Something went wrong.</h2>
                    <p style={{ color: '#555', fontSize: '1.1em' }}>We've securely logged this error and our team will look into it.</p>
                    <p style={{ color: '#555', fontSize: '0.9em', marginTop: '10px' }}>Please try refreshing the page or returning to the dashboard.</p>
                    <button onClick={() => window.location.reload()} style={{ padding: '10px 20px', fontSize: '16px', marginTop: '20px', cursor: 'pointer', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
                        Refresh Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
